import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	nameLabel: {
		id: 'snippets.snippetEditorModal.nameLabel',
		defaultMessage: 'Template Name',
		description: 'Label for the template name input',
	},
	namePlaceholder: {
		id: 'snippets.snippetEditorModal.namePlaceholder',
		defaultMessage: 'Enter template name',
		description: 'Placeholder for the template name input',
	},
	nameError: {
		id: 'snippets.snippetEditorModal.nameError',
		defaultMessage: 'Name is required',
		description: 'Error message for the template name input',
	},
	descriptionLabel: {
		id: 'snippets.snippetEditorModal.descriptionLabel',
		defaultMessage: 'Description',
		description: 'Description label for the modal',
	},
	descriptionPlaceholder: {
		id: 'snippets.snippetEditorModal.descriptionPlaceholder',
		defaultMessage: 'Enter template description',
		description: 'Placeholder for the description input',
	},
	accessLabel: {
		id: 'snippets.snippetEditorModal.accessLabel',
		defaultMessage: 'Access',
		description: 'Label for the Access field (Private/Shared)',
	},
	accessPrivate: {
		id: 'snippets.snippetEditorModal.accessPrivate',
		defaultMessage: 'Private',
		description: 'Private access option for block templates',
	},
	accessShared: {
		id: 'snippets.snippetEditorModal.accessShared',
		defaultMessage: 'Shared',
		description: 'Shared access option for block templates',
	},
	accessPrivateTooltip: {
		id: 'snippets.snippetEditorModal.accessPrivateTooltip',
		defaultMessage: 'Only you can access this template',
		description: 'Tooltip for the Private access button',
	},
	accessSharedTooltip: {
		id: 'snippets.snippetEditorModal.accessSharedTooltip',
		defaultMessage: "'Shared' lets your company access this template sitewide but not edit it.",
		description: 'Tooltip for the Shared access button',
	},
	adfError: {
		id: 'snippets.snippetEditorModal.adfError',
		defaultMessage: 'Something went wrong, please make a new content selection',
		description: 'Error message for when the selected ADF is invalid',
	},
	cancelButton: {
		id: 'snippets.snippetEditorModal.cancelButton',
		defaultMessage: 'Cancel',
		description: 'Cancel button text',
	},
});
